<h1 style="color: #FFF;">Auditorias de Notas</h1>
<div style="display: block" *ngIf="barChartData">
    <canvas baseChart
      [datasets]="barChartData"
      [labels]="barChartLabels"
      [options]="barChartOptions"
      [legend]="barChartLegend"
      [chartType]="barChartType">
    </canvas>
  </div>


<h1 style="color: #FFF;">Auditorias de Cronicas</h1>
<div style="display: block" *ngIf="barChartData">
  <canvas baseChart
    [datasets]="barChartData2"
    [labels]="barChartLabels2"
    [options]="barChartOptions2"
    [legend]="barChartLegend2"
    [chartType]="barChartType2">
  </canvas>
</div>



<h1 style="color: #FFF;">Auditorias de Ensayos</h1>
<div style="display: block" *ngIf="barChartData">
  <canvas baseChart
    [datasets]="barChartData2"
    [labels]="barChartLabels2"
    [options]="barChartOptions2"
    [legend]="barChartLegend2"
    [chartType]="barChartType2">
  </canvas>
</div>